import { create } from "zustand";

/** Lets any component ask the tree to start inline-renaming an item. */
interface RenameRequestState {
  id: string | null;
  nonce: number;
  request: (id: string) => void;
  clear: () => void;
}

export const useRenameRequest = create<RenameRequestState>((set) => ({
  id: null,
  nonce: 0,
  request: (id) => set((s) => ({ id, nonce: s.nonce + 1 })),
  clear: () => set({ id: null }),
}));
